module.exports = __webpack_public_path__ + "static/5-54224603c7765a2dc98daafcdecdd26a.jpg";